import "react-dropdown/style.css";
import { useTranslation } from "react-i18next";
import {
  getDropdownList,
  getParentClientSearch,
} from "./../services/userServices";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ROOT } from "./../navigation/CONSTANTS";
import { generalStoreActions } from "../Store/GeneralStore";
import { useDispatch } from "react-redux";
import BackdropComponent from "../components/Spinner/Spinner";
import SearchIcon from "@mui/icons-material/Search";

export const Sidebar = (props) => {
  const { t } = useTranslation(["sidebar"]);

  const dispatch = useDispatch();
  const locationObj = useLocation();
  const fetchUrl = window.location.pathname.split("/");
  const navigate = useNavigate();
  const [loading, setLoading] = useState([false]);
  const [dropdownData, setDropdownData] = useState([]);
  const [parentClientDetails, setParentClientDetails] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState("RosterId");
  const [traineeSearch, setTraineeSearch] = useState("");

  const [foundList, setFoundList] = useState([]);
  const [showSidebar, setShowSidebar] = useState(true);

  const [selectedParentClient, setSelectedParentClient] = useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let cancelled = false;

    const initialize = async () => {
      setShowSidebar(
        fetchUrl[1].toLocaleLowerCase() !== "home" &&
          fetchUrl[1].toLocaleLowerCase() !== "bireport" &&
          fetchUrl[1].toLocaleLowerCase() !== "log-insights" &&
          fetchUrl[1].toLocaleLowerCase() !== "coreratio",
      );

      if (!cancelled) {
        setLoading(true);
      }

      try {
        const [parentClientDetails, dropdownData] = await Promise.all([
          getParentClientSearch(),
          getDropdownList(),
        ]);

        if (cancelled) return;

        if (dropdownData) {
          if (!cancelled) {
            setDropdownData(dropdownData);
          }
        }

        if (parentClientDetails) {
          if (!cancelled) {
            setFoundList(parentClientDetails);
            setParentClientDetails(parentClientDetails);

            if (locationObj.pathname.startsWith("/parentClient")) {
              const array = window.location.href.split("/");
              setSelectedParentClient(array[array.length - 1]);

              const name = parentClientDetails.filter(
                (item) => item.parentClientCode == array[array.length - 1],
              );

              if (name.length > 0) {
                dispatch(
                  generalStoreActions.updateClassRequestName(
                    name[0].parentClientName,
                  ),
                );
              }
            }
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to initialize:", error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    initialize();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (fetchUrl[1] === "requisitionSearch") {
      setSelectedOptions("RequisitionId");
      setTraineeSearch(fetchUrl[2].replace(/%20/g, " "));
    } else if (fetchUrl[2] === "OracleId") {
      setSelectedOptions("OracleId");
      setTraineeSearch(fetchUrl[3].replace(/%20/g, " "));
    } else if (fetchUrl[2] === "Email") {
      setSelectedOptions("Email");
      setTraineeSearch(fetchUrl[3].replace(/%20/g, " "));
    } else if (fetchUrl[2] === "Name") {
      setSelectedOptions("Name");
      setTraineeSearch(fetchUrl[3].replace(/%20/g, " "));
    } else {
      setSelectedOptions("RosterId");
      setTraineeSearch("");
    }
  }, [locationObj.pathname]);

  const setOptions = (event) => {
    event.preventDefault();
    if (event?.target?.value) {
      setSelectedOptions(event.target.value);
      setTraineeSearch("");
    }
  };

  const navigateToSearch = () => {
    if (traineeSearch && selectedOptions) {
      dispatch(generalStoreActions.updateClassRequestButton(false));
      setSelectedParentClient("");
      if (selectedOptions === "RequisitionId") {
        const path = `/requisitionSearch/${traineeSearch}`;
        navigate(path || ROOT);
      } else if (selectedOptions === "RosterId") {
        dispatch(generalStoreActions.traineeSearch(true));
        const path = `/rosterSearch/null/${traineeSearch}`;
        navigate(path || ROOT);
      } else {
        const path = `/searchResult/${selectedOptions}/${traineeSearch}`;
        navigate(path || ROOT);
      }
    }
  };

  const searchParentClient = (e) => {
    if (e) {
      dispatch(generalStoreActions.updateParentClientProject(""));
      dispatch(generalStoreActions.updateSiteLocation(""));
      setSelectedParentClient(e.parentClientCode);
      dispatch(generalStoreActions.updateClassRequestName(e.parentClientName));
      dispatch(generalStoreActions.traineeSearch(false));
      const path = `/parentClient/${e.parentClientCode}`;
      navigate(path || ROOT);
    }
  };

  const filter = (e) => {
    const keyword = e.target.value;

    if (keyword !== "") {
      const results = parentClientDetails.filter((user) => {
        return (
          user.parentClientName.toLowerCase().includes(keyword.toLowerCase()) ||
          user.parentClientCode.toLowerCase().includes(keyword.toLowerCase())
        );

        // return user.parentClientName.toLowerCase().includes(keyword.toLowerCase());
        // Use the toLowerCase() method to make it case-insensitive
      });
      setFoundList(results);
    } else {
      setFoundList(parentClientDetails);
      // If the text field is empty, show all users
    }
  };

  return (
    showSidebar && (
      <div className={"side-bar"}>
        {loading ? <BackdropComponent /> : null}
        <div className={"sidebar-section trainee-section"}>
          <div className="sidebar-title">{t("traineeSearch")}</div>
          <div>
            <select
              onChange={(e) => setOptions(e)}
              className="dropdown-css"
              value={selectedOptions}
              placeholder="Select an option"
            >
              {dropdownData.map((value, index) => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
            </select>
          </div>
          <div className="only-flex rdd">
            <input
              className={"trainee-input"}
              placeholder={t("Search")}
              value={traineeSearch}
              onChange={(e) => {
                let regEx = /(^[+-]?\d*[.]?\d*$)/;
                if (selectedOptions === "RosterId") {
                  regEx.test(e.target.value) &&
                    setTraineeSearch(e.target.value);
                } else {
                  setTraineeSearch(e.target.value);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  navigateToSearch();
                }
              }}
            />
            <SearchIcon
              onClick={navigateToSearch}
              className="searchIcon"
            ></SearchIcon>
          </div>
        </div>
        <div className={"sidebar-section parent-section"}>
          <div className="sidebar-title">{t("parentCLientSearch")}</div>
          <div className="only-flex">
            <input
              onChange={filter}
              className={"trainee-input"}
              placeholder={t("Search")}
            ></input>
            <SearchIcon
              onClick={navigateToSearch}
              className="searchIcon"
            ></SearchIcon>
          </div>
          <div className="search-list">
            {foundList.map((item) => (
              <div
                key={item.parentClientCode}
                id={item.parentClientCode}
                onClick={() => searchParentClient(item)}
                onKeyDown={() => searchParentClient(item)}
                className={`search-item ${
                  item.parentClientCode === selectedParentClient
                    ? "is-active"
                    : ""
                }`}
              >
                {item.parentClientName} - {item.parentClientCode}
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  );
};

export default Sidebar;
